import KortoBold from "./Korto-Bold.ttf"
import KortoBoldOblique from "./Korto-BoldOblique.ttf"
import KortoBook from "./Korto-Book.ttf"
import KortoBookOblique from "./Korto-BookOblique.ttf"
import KortoHeavy from "./Korto-Heavy.ttf"
import KortoHeavyOblique from "./Korto-HeavyOblique.ttf"
import KortoLight from "./Korto-Light.ttf"
import KortoLightOblique from "./Korto-LightOblique.ttf"
import KortoMedium from "./Korto-Medium.ttf"
import KortoMediumOblique from "./Korto-MediumOblique.ttf"
import KortoThin from "./Korto-Thin.ttf"
import KortoThinOblique from "./Korto-ThinOblique.ttf"
import KortoUltra from "./Korto-Ultra.ttf"
import KortoUltraOblique from "./Korto-UltraOblique.ttf"

const Korto = {
  KortoBold,
  KortoBoldOblique,
  KortoBook,
  KortoBookOblique,
  KortoHeavy,
  KortoHeavyOblique,
  KortoLight,
  KortoLightOblique,
  KortoMedium,
  KortoMediumOblique,
  KortoThin,
  KortoThinOblique,
  KortoUltra,
  KortoUltraOblique,
}

export default Korto
